import { createSlice, Draft } from '@reduxjs/toolkit'
import { ICabinetsInfoResponseDto } from '../../dto/cabinets/cabinetsInfo/cabinetsInfo.response.dto'

export interface ICabinetsInfo {
  cabinetList: ICabinetsInfoResponseDto;
  pagination: {
    current: number;
    pageSize: number;
  }
}

const initialState: ICabinetsInfo = {
  cabinetList: {
    cabinets: [],
    meta: {
      total: 0,
      active: 0,
      inactive: 0,
    }
  },
  pagination: {
    current: 1,
    pageSize: 10
  }
}

export const cabinetsInfoSlice = createSlice({
  name: 'cabinetList',
  initialState,
  reducers: {
    setDefaultCabinetList: (state: Draft<ICabinetsInfo>) => {
      state.cabinetList = initialState.cabinetList;
    },
    setCabinetsInfoSlice: (state: Draft<ICabinetsInfo>, { payload }) => {
      state.cabinetList = payload
    },
    setCabinetsPagination: (state: Draft<ICabinetsInfo>, { payload }: { payload: ICabinetsInfo['pagination'] }) => {
      state.pagination = payload;
    },
  }
})

export const { setCabinetsInfoSlice, setCabinetsPagination, setDefaultCabinetList } = cabinetsInfoSlice.actions

export default cabinetsInfoSlice.reducer
